import { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@zep/auth';
import { withPageSuspense } from '@zep/next';
import { useStoreSubLayoutLeftButtons, useStoreSubLayoutRightButtons } from '../../../consts';
import { StorePageType } from '../../../types/StoreTypes';
import { DefaultLayout } from '../DefaultLayout';
import { SubLayout, SubLayoutProps } from './SubLayout';
export const StoreLayout = withPageSuspense((props: StoreLayoutProps) => {
  const {
    user
  } = useAuth();
  const {
    query
  } = useRouter();
  const currentPage = query.type as StorePageType;
  const leftButtons = useStoreSubLayoutLeftButtons();
  const rightButtons = useStoreSubLayoutRightButtons(!!user?.isEdu);
  return <DefaultLayout>
      <SubLayout currentPage={currentPage} leftButtons={leftButtons} rightButtons={rightButtons} {...props} />
    </DefaultLayout>;
});
export const getStoreLayout = (page: ReactElement, storeLayoutProps?: StoreLayoutProps) => <StoreLayout {...storeLayoutProps} data-sentry-element="StoreLayout" data-sentry-component="getStoreLayout" data-sentry-source-file="StoreLayout.tsx">{page}</StoreLayout>;
type StoreLayoutProps = Partial<Omit<SubLayoutProps, 'children'>>;